<script setup>
// A notice on the overview (phase 4.5): the kit's Alert with a warning icon, the sentence, one action and a close
// button. The kit has no "warning" Alert yet (R2-T-P8 asked the kit for it); the default one carries the icon.
import { Close16, WarningAlt16 } from '@carbon/icons-vue';
import {
  Alert,
  AlertDescription,
} from 'dashboard/components-next/polaris/ui/alert';
import { Button } from 'dashboard/components-next/polaris/ui/button';

defineProps({
  text: { type: String, required: true },
  actionLabel: { type: String, required: true },
  dismissLabel: { type: String, required: true },
});
const emit = defineEmits(['action', 'dismiss']);
</script>

<template>
  <Alert role="status" data-overview-banner>
    <WarningAlt16 aria-hidden="true" />
    <AlertDescription
      class="flex flex-wrap items-center justify-between gap-x-3 gap-y-2 text-polaris-foreground"
    >
      <span class="min-w-0">{{ text }}</span>
      <span class="flex shrink-0 items-center gap-1">
        <Button variant="outline" size="sm" @click="emit('action')">
          {{ actionLabel }}
        </Button>
        <Button
          variant="ghost"
          size="icon-sm"
          :aria-label="dismissLabel"
          @click="emit('dismiss')"
        >
          <Close16 aria-hidden="true" />
        </Button>
      </span>
    </AlertDescription>
  </Alert>
</template>
